import React, {Component} from "react";
import { Typography, Grid, Box } from '@material-ui/core';
import TitleText from "./TitleText";

class KontenTextImage extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }

    

    render() { 
        return (
            <div className="text-background main-bg-color" style={{padding: 10, width: 620}}>
                <Grid container spacing={2}>
                    <Grid item>
                        <img src={this.props.logo} width="130%"/>
                    </Grid>
                    <Grid item>
                        <div className="text-putih2">{this.props.title}</div>
                        <div className="text-putih3">{this.props.subTitle}</div>
                    </Grid>
                </Grid>
            </div>
        );
    }
}
 
export default KontenTextImage;